<template>
    <div class="el-image-input border-0">
        <div class="image-input d-flex">
            <div class="m-auto">
                <upload-partial name="csv-input" :hide="['url', 'library']" :type="'small'" :multiple="false" @change="fileChanged" @on-error="(driveError) => { error = driveError }" :accept="'csv'"></upload-partial>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import UploadPartial from "@/components/elements/partials/upload-partial";
import Papa from 'papaparse';

export default {
    name: 'el-csv-upload',

    components: { UploadPartial },

    props: {

        /**
         * Array defining the csv value
         * @type {Array}
         */
        value: {
            required: true,
            type: Array
        }
    },

    data: () => ({
        input: [],
        file: {},
        error: [],
        csv: null,
        sample: null,
    }),

    methods: {
        fileChanged(fieldName, fileList) {
            if (!fileList.length) return;
            let self = this;

            for (var i = 0, file; (file = fileList[i]); i++) {
                if (file) {
                    let reader = new FileReader();
                    reader.readAsText(file, "UTF-8");
                    reader.onload = function (evt) {
                        let results = [];
                        self.csv = _.get(Papa.parse(evt.target.result), "data");
                        self.csv.forEach((columns) => {
                            results.push({
                                first_name: columns[0],
                                last_name: columns[1],
                                email: columns[2].toLowerCase()
                            })
                        })
                        self.$emit("input", results);
                    };
                    reader.onerror = function () {
                    };
                }
            }
        },
    }
}
</script>
